module.exports = __webpack_public_path__ + "static/media/wind-turbine.2de5e7eb.svg";